import { serverMessage } from '@/Ship/Helpers/serverError'

/**
 * Пояснення помилки `restClient` або `undefined`, якщо його немає.
 *
 * Тонка обгортка над спільним `serverMessage`: логіка розбору відповіді одна на
 * весь проєкт. Цей хелпер з'явився раніше за неї і робив те саме, але з власною
 * копією правил — саме через такі копії помилки сервера в решті проєкту
 * показувалися сирим текстом ky.
 *
 * Відрізняється лише контрактом: тут потрібне `undefined`, коли сервер нічого не
 * пояснив, — виклики самі вирішують, чи показувати щось замість нього.
 */
export function getErrorMessage(error: unknown): string | undefined {
    const marker = ''
    const message = serverMessage(error, marker)

    return message === marker ? undefined : message
}
